import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const AdminRoute: React.FC = () => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div className="flex justify-center items-center h-screen"><i className="fas fa-spinner fa-spin text-4xl"></i></div>;
    }

    // Only allow the admin user
    if (user && user.email === 'impresion007@gmail.com') {
        return <Outlet />;
    }

    // If a user is logged in but is not the admin, redirect to homepage
    if (user) {
        return <Navigate to="/" replace />;
    }

    // If no user is logged in, redirect to the admin login page
    return <Navigate to="/login" replace />;
};

export default AdminRoute;
